function generateDefaultInitialGoogleAdUnitsState() {
  return {
    listingPageGoogleAd: null,
  };
}

function googleAdUnitsReducer(state = generateDefaultInitialGoogleAdUnitsState(), action) {
  let newState;
  switch (action.type) {
    case 'GET_GOOGLE_AD_UNIT_LISTING_PAGE_FULFILLED': {
      newState = {
        ...state,
        listingPageGoogleAd: action?.payload?.response?.data?.data || null,
      };

      break;
    }

    case 'CLEAR_GOOGLE_AD_UNITS': {
      newState = {
        listingPageGoogleAd: null,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default googleAdUnitsReducer;
export {generateDefaultInitialGoogleAdUnitsState};
